import { ref } from 'vue'

import { updateUrlParameters } from '../../Methods/utils'

import NewCarLoanCalculatorInputs from '../NewCarLoanCalculatorInputs/NewCarLoanCalculatorInputs.vue'
import debounce from "../../../../foundation/js/debounce";

export default {
    name: 'NewCarLoanCalculatorAdjustLoan',
    components: {
        NewCarLoanCalculatorInputs
    },
    props: {
        labelsInput: {
            type: Object,
            required: true,
        },
        labelsError:{
            type: Object,
            required: true,
        },
        optionsInput: {
            type: Object,
            required: true,
        },
        onCloseCallBack: {
            type: Function,
            required: true,
        },
        callback: {
            type: Function,
            required: true,
        },
    },
    setup(props) {
        const displayErrors = ref(true)

        const isFormValid = ref(true)
        const carPrice = ref('')
        const downPayment = ref('')
        const loanTerm = ref('')
        

        const onCloseCallback = () => {
            props.onCloseCallBack()
        }

        const handleCallback = (data) => {
            isFormValid.value = data.isFormValid

            if (!isFormValid.value) return

            carPrice.value = data.carPrice
            downPayment.value = data.downPayment
            loanTerm.value = data.loanTerm

            const mappedUrlParameters = {
                cp: carPrice.value,
                dp: downPayment.value,
                lt: loanTerm.value
            }
            updateUrlParameters(mappedUrlParameters)

            if(props.callback) {
                props.callback(data)
            }
        };

        const onChangeCallback = debounce(handleCallback, 1000)

        return {
            displayErrors,
            onChangeCallback,
            onCloseCallback,
        }
    },
}